export const parse = (data, keyBuilder = null) =>
	data.reduce((acc, current) => {
		const len = Object.keys(current).length;
		let syblings = acc;
		let parent = null;

		for (let level = 1; level <= len; level += 1) {
			const code = keyBuilder ? keyBuilder.code(level) : `aP_L${level}Code`;
			const nameKey = keyBuilder
				? keyBuilder.nameKey(level)
				: `aP_L${level}Category`;
			const name = current[nameKey];
			const id = current[code] || name;

			if (id && name) {
				if (!syblings[id]) {
					syblings[id] = {
						id: id,
						name: name,
						code: code,
						level,
						children: {},
						originalData: current,
						parent,
						syblings,
					};
				}
				parent = syblings[id];
				syblings = syblings[id].children;
			}
		}

		return acc;
	}, {});

export const createMap = (data, keyBuilder = null) => {
	const map = {};

	data.forEach(item => {
		const len = Object.keys(item).length;

		for (let i = 1; i <= len; i += 1) {
			const code = keyBuilder ? keyBuilder.code(i) : `aP_L${i}Code`;
			const nameKey = keyBuilder ? keyBuilder.nameKey(i) : `aP_L${i}Category`;
			const name = item[nameKey];
			const id = item[code];

			if (id && !map[id]) {
				map[id] = name;
			}
		}
	});

	return map;
};

export const getCodeFromItem = (item, keyBuilder = null) => {
	const len = Object.keys(item).length;

	for (let i = len; i > 0; i -= 1) {
		const code = keyBuilder ? keyBuilder.code(i) : `aP_L${i}Code`;
		const id = item[code];
		const nameKey = keyBuilder ? keyBuilder.nameKey(i) : `aP_L${i}Category`;
		const name = item[nameKey];

		if (id) {
			return { id, name };
		}
	}

	return {};
};

export const getItemByCode = (data, searchCode, keyBuilder = null) => {
	let result = null;

	data.find(item => {
		const len = Object.keys(item).length;
		const acc = {};

		for (let i = 1; i <= len; i += 1) {
			const code = keyBuilder ? keyBuilder.code(i) : `aP_L${i}Code`;
			const id = item[code];

			acc[code] = id;

			if (id === searchCode) {
				result = acc;

				return true;
			}
		}

		return false;
	});

	return result;
};

export const industryKeyBuilder = {
	code: i => `ap_indus_v0.1_L${i}_Code`,
	nameKey: i => `ap_indus_v0.1_L${i}`,
};
